import React from 'react'

import { VideoTrack } from '../../../../MediaTracks/components/VideoTrack/VideoTrack'
import { useParticipant } from '../../../../webrtc/webRTCRoom'
import { TrackPositioner } from '../TrackPositioner/TrackPositioner'

interface FloorCameraFeedProps {
  id: number
}

const FloorScreenFeed = ({ id }: FloorCameraFeedProps) => {
  const participant = useParticipant(id)

  if (!participant?.tracks.screen) return null

  return (
    <TrackPositioner trackId={id} trackType="screen">
      <VideoTrack track={participant.tracks.screen} />
    </TrackPositioner>
  )
}

export { FloorScreenFeed }
